var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"result":_vm.formattedResult},on:{"open-profile":_vm.onItemClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }